import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { detectLanguage, getTranslation } from './translations';
import { ToastProvider } from './context/ToastContext';
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import VideoConferenceShowcase from './components/VideoConferenceShowcase';
import FeaturesSection from './components/FeaturesSection';
import HowItWorksSection from './components/HowItWorksSection';
import PricingSection from './components/PricingSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import DownloadPage from './pages/DownloadPage';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import RefundPolicy from './pages/RefundPolicy';
import CookiePolicy from './pages/CookiePolicy';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import AdminDashboard from './pages/AdminDashboard';
import AdminRoute from './components/AdminRoute';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import PageNotFound from './components/PageNotFound';

function HomePage() {
  const [lang, setLang] = useState('en');
  const [t, setT] = useState(getTranslation('en'));

  useEffect(() => {
    // Check localStorage first for user preference
    const savedLang = localStorage.getItem('preferredLanguage');
    const detectedLang = savedLang || detectLanguage();
    setLang(detectedLang);
    setT(getTranslation(detectedLang));
  }, []);

  const handleLanguageChange = (newLang: string) => {
    setLang(newLang);
    setT(getTranslation(newLang));
    localStorage.setItem('preferredLanguage', newLang);
  };

  return (
    <div className="font-sans antialiased bg-gray-50">
      <Navigation t={t} currentLang={lang} onLanguageChange={handleLanguageChange} />
      <HeroSection t={t} />
      <VideoConferenceShowcase t={t} />
      <FeaturesSection t={t} />
      <HowItWorksSection t={t} />
      <PricingSection t={t} language={lang} />
      <CTASection t={t} />
      <Footer t={t} />
    </div>
  );
}

function App() {
  return (
    <ToastProvider>
      <Router>
        <Routes>
        <Route path="/" element={<PageNotFound />} />
        <Route path="/ttt" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route 
          path="/dashboard/mgmt" 
          element={
            <AdminRoute>
              <AdminDashboard />
            </AdminRoute>
          } 
        />
        <Route path="/download" element={<DownloadPage />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/refund" element={<RefundPolicy />} />
        <Route path="/cookies" element={<CookiePolicy />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/payment-success" element={<PaymentSuccessPage />} />
        </Routes>
      </Router>
    </ToastProvider>
  );
}

export default App;
